import type { ForecasterAudienceBlocks } from '@/Interfaces/AudienceTemplates/AudienceBlock.interface';
import { formatAudienceExpression } from '@/helpers/audience/formatAudienceExpression';
import { Close } from '@mui/icons-material';
import { Box, IconButton, Typography } from '@mui/material';

interface IProps {
  value: ForecasterAudienceBlocks;
  onRemoveBlock: (rowIndex: number, blockIndex: number) => void;
}

const AudienceBlockList = ({ value, onRemoveBlock }: IProps) => {
  if (!value?.length) {
    return null;
  }
  const rows = value.filter(row => row.length);
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, width: '100%' }}>
      {rows.map((row, rowIndex) => (
        <Box key={row[0]?.id ?? rowIndex} sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {rowIndex > 0 && <Typography sx={{ fontWeight: 700, color: 'primary.main', fontSize: 14 }}>AND</Typography>}
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, alignItems: 'center' }}>
            {row.map((block, blockIndex) => (
              <Box key={block.id} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                {blockIndex > 0 && (
                  <Typography sx={{ fontWeight: 700, color: 'primary.main', fontSize: 12 }}>OR</Typography>
                )}
                <Box
                  sx={{
                    border: '1px solid',
                    borderColor: 'grey.400',
                    borderRadius: '8px',
                    p: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.5,
                    minWidth: 120,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
                    <Typography sx={{ fontWeight: 600, fontSize: 12 }}>{block.label}</Typography>
                    <IconButton
                      size='small'
                      sx={{ '@media print': { display: 'none' } }}
                      aria-label={`Remove ${block.label}`}
                      onClick={() => onRemoveBlock(rowIndex, blockIndex)}
                    >
                      <Close fontSize='small' />
                    </IconButton>
                  </Box>
                  <Typography sx={{ fontSize: 12, color: 'text.secondary' }}>
                    {formatAudienceExpression(block.targeting.include, block.targeting.exclude)}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default AudienceBlockList;
